import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AreasRoutingModule } from './areas-routing.module';
import { SharedModule } from './../utils/shared.module';
import { CoreModule } from '../core/core.module';
import { LoginComponent } from './login/login.component';
import { MainModule } from './main/main.module';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { NgxMaskModule } from 'ngx-mask';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ActivateaccountComponent } from './login/activateaccount/activateaccount.component';
import { AppConfig } from '../utils/app-config.service';
import { AgentaccessComponent } from './login/agentaccess/agentaccess.component';
import { SignupComponent } from './signup/signup.component';
import { SmsverificationComponent } from './signup/smsverification/smsverification.component';
import { SmsaddcodeComponent } from './signup/smsaddcode/smsaddcode.component';
import { AccountconfirmedComponent } from './signup/accountconfirmed/accountconfirmed.component';
import { MailComponent } from './signup/mail/mail.component';
import { OnboardingRedirector } from '../utils/onboardingredirector';
import { ThemeSelectorComponent } from '../shared/theme-selector/theme-selector.component';
import { LoadingScreenDialogComponent } from './ui/loading-screen-dialog/loading-screen-dialog.component';
import { TwoFAComponent } from './login/two-fa/two-fa.component';
import { TwoFAokComponent } from './login/two-fa/two-faok/two-faok.component';
import { TooManyAttemptsComponent } from './login/two-fa/too-many-attempts/too-many-attempts.component';
import { RegisterComponent } from './register/register.component';
import { LoadingcustodianComponent } from './ui/loadingcustodian/loadingcustodian.component';
/*
export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}*/

@NgModule({
  id: 'tech-areas-module',
  declarations: [
    LoginComponent,
    PageNotFoundComponent,
    RecoverPasswordComponent,
    ResetPasswordComponent,
    ActivateaccountComponent,
    AgentaccessComponent,
    SignupComponent,
    SmsverificationComponent,
    SmsaddcodeComponent,
    AccountconfirmedComponent,
    MailComponent,
    LoadingScreenDialogComponent,        
    TwoFAComponent,
    TwoFAokComponent,
    TooManyAttemptsComponent,
    RegisterComponent,
    LoadingcustodianComponent,
  ],
  providers: [
    AppConfig,
    OnboardingRedirector,
    /*
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },*/
  ],
  imports: [
    CoreModule,
    SharedModule,
    MainModule,
    AreasRoutingModule,
    NgxMaskModule,
  ],
})
export class AreasModule {}
